import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans du socle chargés à la demande (budget d'affichage SC-003).
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const AdminPage = page(() => import('./admin/AdminPage.js'), 'AdminPage');
const PersonsPage = page(() => import('./persons/PersonsPage.js'), 'PersonsPage');
const PersonPage = page(() => import('./persons/PersonPage.js'), 'PersonPage');
const MyPersonPage = page(() => import('./persons/PersonPage.js'), 'MyPersonPage');
const OrganizationsPage = page(
  () => import('./organizations/OrganizationsPage.js'),
  'OrganizationsPage',
);
const OrganizationPage = page(
  () => import('./organizations/OrganizationsPage.js'),
  'OrganizationPage',
);
const DuplicatesPage = page(() => import('./duplicates/DuplicatesPage.js'), 'DuplicatesPage');
const AdminFieldsPage = page(() => import('./admin-data/AdminFieldsPage.js'), 'AdminFieldsPage');
const DeadlinesPage = page(() => import('./admin-data/DeadlinesPage.js'), 'DeadlinesPage');
const MyDeadlinesPage = page(() => import('./admin-data/DeadlinesPage.js'), 'MyDeadlinesPage');
const AlertRulesPage = page(() => import('./alerts/AlertRulesPage.js'), 'AlertRulesPage');
const DeliveriesPage = page(() => import('./alerts/DeliveriesPage.js'), 'DeliveriesPage');
const NotificationsPage = page(() => import('./alerts/NotificationsPage.js'), 'NotificationsPage');
const StructurePage = page(() => import('./structure/StructurePage.js'), 'StructurePage');
const CommunesPage = page(() => import('./structure/SectorPages.js'), 'CommunesPage');
const UnassignedPage = page(() => import('./structure/SectorPages.js'), 'UnassignedPage');
const ProfilesPage = page(() => import('./profiles/ProfilesPage.js'), 'ProfilesPage');
const RightsPage = page(() => import('./rights/RightsPage.js'), 'RightsPage');
const ResponsablesPage = page(() => import('./rights/ResponsablesPage.js'), 'ResponsablesPage');
const DriftPage = page(() => import('./drift/DriftPage.js'), 'DriftPage');
const CloudFoldersPage = page(() => import('./files/CloudFoldersPage.js'), 'CloudFoldersPage');
const PrivacyPage = page(() => import('./privacy/PrivacyPage.js'), 'PrivacyPage');
const WorkflowItemPage = page(() => import('./workflows/WorkflowPages.js'), 'WorkflowItemPage');
const WorkflowItemsPage = page(() => import('./workflows/WorkflowPages.js'), 'WorkflowItemsPage');
const MyRequestsPage = page(() => import('./workflows/WorkflowPages.js'), 'MyRequestsPage');
const DocumentTemplatesPage = page(
  () => import('./documents/DocumentTemplatesPage.js'),
  'DocumentTemplatesPage',
);
const ModuleSettingsPage = page(
  () => import('./admin/ModuleSettingsPage.js'),
  'ModuleSettingsPage',
);
const ReprisePage = page(() => import('./import/ReprisePage.js'), 'ReprisePage');

export const socleWeb: ModuleWeb = {
  module: 'socle',
  routes: [
    { path: '/administration', element: <AdminPage /> },
    { path: '/administration/reglages', element: <ModuleSettingsPage /> },
    { path: '/personnes', element: <PersonsPage /> },
    { path: '/personnes/:id', element: <PersonPage /> },
    { path: '/ma-fiche', element: <MyPersonPage /> },
    { path: '/organismes', element: <OrganizationsPage /> },
    { path: '/organismes/:id', element: <OrganizationPage /> },
    { path: '/doublons', element: <DuplicatesPage /> },
    { path: '/donnees-administratives', element: <AdminFieldsPage /> },
    { path: '/echeances', element: <DeadlinesPage /> },
    { path: '/mes-echeances', element: <MyDeadlinesPage /> },
    { path: '/alertes', element: <AlertRulesPage /> },
    { path: '/envois', element: <DeliveriesPage /> },
    { path: '/notifications', element: <NotificationsPage /> },
    { path: '/structure', element: <StructurePage /> },
    { path: '/structure/communes', element: <CommunesPage /> },
    { path: '/fiches-sans-secteur', element: <UnassignedPage /> },
    { path: '/profils', element: <ProfilesPage /> },
    { path: '/droits', element: <RightsPage /> },
    { path: '/responsables', element: <ResponsablesPage /> },
    { path: '/ecarts-annuaire', element: <DriftPage /> },
    { path: '/dossiers-cloud', element: <CloudFoldersPage /> },
    { path: '/rgpd', element: <PrivacyPage /> },
    { path: '/circuits', element: <WorkflowItemsPage /> },
    { path: '/circuits/:id', element: <WorkflowItemPage /> },
    { path: '/mes-demandes', element: <MyRequestsPage /> },
    { path: '/modeles-documents', element: <DocumentTemplatesPage /> },
    { path: '/reprise', element: <ReprisePage /> },
  ],
};
